<div class="trinka_cloud_wrap">
    <div id="particles-js"></div>

    <section class="mainTopBanner">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="topBannerWrapper">
                        <div class="top-banner-left">
                            <h1>教育 & eラーニング</h1>
                            <h2>Trinkaで学生にライティングサポートを。英語の習熟度評価も</h2>
                                <p>英文校正ツールTrinka（トリンカ）に搭載された高度なAIで、学生は英文を改善できるだけでなく、アカデミックライティングのスキルを向上させられます。英文ライティングの習熟度を評価するための機能もあり、教員から学生への的確なフィードバックも可能です。</p>
                                <div class="btn-group">
                                    <button style="margin: 0; padding: 0;" id="salesContactButtons" data-toggle="modal"
                                    data-target="#EnterPriseContactPopup" class="filled-btn" type="submit">お問い合わせ</button>
                                </div>
                        </div>
                        <div class="top-banner-right">
                            <img src="../../../assets/images/K12-and-elearning.png" alt="教育 & eラーニング - 文法 チェック" class="img-fluid md50">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section class="section-pd trinka-key-features">
        <div class="trinka_container">
            <div class="row justify-content-center">
                <div class="col-md-10 col-lg-8">
                    <div class="trinka-title mb-0 text-center">
                        <h2>こんなお客様におすすめ</h2>
                        <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="gt-features">
                        <span class="hr-line d-sm-none"></span>
                        <span class="vr-line l25 d-sm-block d-none"></span>
                        <span class="vr-line l50"></span>
                        <span class="vr-line l75 d-sm-block d-none"></span>
                        <div class="gt-wrapper c-card">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                <circle cx="10" cy="10" r="10" fill="#763393"/>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M14.8277 6.67085C15.0574 6.89866 15.0574 7.26801 14.8277 7.49581L8.94536 13.3291C8.71564 13.557 8.34319 13.557 8.11347 13.3291L5.17229 10.4125C4.94257 10.1847 4.94257 9.81533 5.17229 9.58752C5.40201 9.35972 5.77446 9.35972 6.00418 9.58752L8.52941 12.0917L13.9958 6.67085C14.2255 6.44305 14.598 6.44305 14.8277 6.67085Z" fill="white"/>
                            </svg>
                            <h6>教育機関</h6>
                        </div>
                        <div class="gt-wrapper c-card">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                <circle cx="10" cy="10" r="10" fill="#763393"/>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M14.8277 6.67085C15.0574 6.89866 15.0574 7.26801 14.8277 7.49581L8.94536 13.3291C8.71564 13.557 8.34319 13.557 8.11347 13.3291L5.17229 10.4125C4.94257 10.1847 4.94257 9.81533 5.17229 9.58752C5.40201 9.35972 5.77446 9.35972 6.00418 9.58752L8.52941 12.0917L13.9958 6.67085C14.2255 6.44305 14.598 6.44305 14.8277 6.67085Z" fill="white"/>
                            </svg>
                            <h6>研究機関</h6>
                        </div>
                        <div class="gt-wrapper c-card">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                <circle cx="10" cy="10" r="10" fill="#763393"/>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M14.8277 6.67085C15.0574 6.89866 15.0574 7.26801 14.8277 7.49581L8.94536 13.3291C8.71564 13.557 8.34319 13.557 8.11347 13.3291L5.17229 10.4125C4.94257 10.1847 4.94257 9.81533 5.17229 9.58752C5.40201 9.35972 5.77446 9.35972 6.00418 9.58752L8.52941 12.0917L13.9958 6.67085C14.2255 6.44305 14.598 6.44305 14.8277 6.67085Z" fill="white"/>
                            </svg>
                            <h6>英語学習アプリ開発業者</h6>
                        </div>
                        <div class="gt-wrapper c-card">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                <circle cx="10" cy="10" r="10" fill="#763393"/>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M14.8277 6.67085C15.0574 6.89866 15.0574 7.26801 14.8277 7.49581L8.94536 13.3291C8.71564 13.557 8.34319 13.557 8.11347 13.3291L5.17229 10.4125C4.94257 10.1847 4.94257 9.81533 5.17229 9.58752C5.40201 9.35972 5.77446 9.35972 6.00418 9.58752L8.52941 12.0917L13.9958 6.67085C14.2255 6.44305 14.598 6.44305 14.8277 6.67085Z" fill="white"/>
                            </svg>
                            <h6>eラーニングプラットフォーム提供業者</h6>
                        </div>
                    </div>            
                </div>
            </div>
        </div>
    </section>

    <div class="brandLogo_sections">
        <div class="container">
            <div class="row">
                <div class="col-sm-2">
                    <h2>世界のトップ企業、学術機関もご利用</h2>
                </div>
                <div class="col-sm-10">
                    <div class="cover_wrapper">
                        <div id="client-logos-enterprise" class="owl-carousel">
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/paterson.png" alt="paterson - 文法 チェック">
                                </div>
                            </div>

                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/abraham-lincoln.png" alt="lincoln - 英文校正">
                                </div>
                            </div>
                            <!-- <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/AmericanCollegeofGreece.png" alt="">
                                </div>
                            </div> -->
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/act.png" alt="american college of thessaloniki - 英文チ ェッカー">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/AguaFriaUnion.png" alt="agua - 英文校正">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/almosa.png" alt="alomsa - 英文校正">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/amalAcademy.png" alt="amal - 文法 チェック">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/AmericanschoolofDubai.png" alt="american">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/lusaka.png" alt="lusaka - 文法 チェック">
                                </div>
                            </div>

                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
    
    <div class="section-pd list-wrapper-style-2">
        <div class="trinka_container">
            <div class="row justify-content-center">
                <div class="col-md-11 col-lg-10">
                    <div class="trinka-title mb-0 text-center">
                        <h2>学生・教職員に最適な質の高い英語ライティング支援</h2>
                        <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                        <p>Trinkaは、学生が英文を改善し、アカデミックライティングの基準を学ぶのに役立ちます。教員の皆様も学生の英文についての多角的なレポートを得られます。</p>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-6 col-md-6">
                    <div class="list-wrapper-content-2 list-style-cards flex-title bt-none">
                        <div class="features_cards_icon">
                            <img src="../../../assets/images/Real-timewritingsuggestions.png" alt="英文チ ェッカー" srcset="">
                        </div>
                        <div class="features_cards_desc">
                            <h3>リアルタイムで提示される改善案</h3>
                            <p>Trinkaは、学術的な英文に特化したライティングアシスタントです。複雑な文法ミスの修正だけなく、語彙、トーン、構文などの改善も提案します。詳細な提案を通じてライティングスキルを学ぶこともできます。
                            </p>
                        </div>
                    </div>
                </div>

                <div class="col-lg-6 col-md-6">
                    <div class="list-wrapper-content-2 list-style-cards flex-title">
                        <div class="features_cards_icon">
                            <img src="../../../assets/images/Automatedfilecorrections.png" alt="自動ファイル - 英文校正" srcset="">
                        </div>
                        <div class="features_cards_desc">
                            <h3>自動ファイル修正と修正箇所レポート</h3>
                            <p>MS Wordファイルをアップロードするだけで、数分で文書全体の校正が完了。修正箇所のレポートで、ご自身の英文の評価をすぐにご覧いただけます。
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 col-md-6">
                    <div class="list-wrapper-content-2 list-style-cards flex-title bt-1">
                        <div class="features_cards_icon">
                            <img src="../../../assets/images/Qualityassessment.png" alt="品質評価 - 文法 チェック" srcset="">
                        </div>
                        <div class="features_cards_desc">
                            <h3>学生の習熟度を測るスコア機能</h3>
                            <p>カスタマイズ可能な採点アルゴリズムで、英語ライティングの質をリアルタイムで把握可能。詳細な解説と修正案の提案で、ライティングスキルも習得できます。
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 col-md-6">
                    <div class="list-wrapper-content-2 list-style-cards flex-title bt-1">
                        <div class="features_cards_icon">
                            <img src="../../../assets/images/ComprehensiveAnalytics.svg" alt="総合的な分析 - ai英文校正" srcset="">
                        </div>
                        <div class="features_cards_desc">
                            <h3>総合的な分析</h3>
                            <p>Trinkaの利用状況や、各ユーザーの行動を掘り下げて分析することで、効果的に評価やフィードバックを行えます。
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 col-md-6">
                    <div class="list-wrapper-content-2 list-style-cards flex-title bt-1">
                        <div class="features_cards_icon">
                            <img src="../../../assets/images/ppc_icon.png" width="40" height="40" alt=">盗用・剽窃チェック - 英文 チェック ai" srcset="">
                        </div>
                        <div class="features_cards_desc">
                            <h3>盗用・剽窃チェック </h3>
                            <p>iThenticate® が誇る最先端のテキスト類似性検出アルゴリズムと、最大級の有料出版物データベースによる高品質の盗用・剽窃チェック</p>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 col-md-6">
                    <div class="list-wrapper-content-2 list-style-cards flex-title bt-1">
                        <div class="features_cards_icon">
                            <img src="../../../assets/images/FileLevelRestrictions.svg" alt="ファイルレベル - 英文校正 ai" srcset="">
                        </div>
                        <div class="features_cards_desc">
                            <h3>ファイルレベルのコントロール</h3>
                            <p>Trinkaのきめ細かなコントロール機能により、学生や遠隔学習者のアクセス管理も簡単で安全です。
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 col-md-6">
                    <div class="list-wrapper-content-2 list-style-cards flex-title bt-1">
                        <div class="features_cards_icon">
                            <img src="../../../assets/images/EasyUserManagement.svg" alt="シンプルなユーザー管理 - 英文チ ェッカー" srcset="">
                        </div>
                        <div class="features_cards_desc">
                            <h3>シンプルなユーザー管理</h3>
                            <p>アクセス制限やライセンスの移行、メンバーの追加も簡単です。</p>
                        </div>
                    </div>

                </div>
                <div class="col-lg-6 col-md-6">
                    <div class="list-wrapper-content-2 list-style-cards flex-title bt-1">
                        <div class="features_cards_icon">
                            <img src="../../../assets/images/DedicatedSupport.svg" alt="専用のサポート - ai英文校正" srcset="">
                        </div>
                        <div class="features_cards_desc">
                            <h3>手厚いサポート体制</h3>
                            <p>専任のスタッフが、お客様のチームにTrinkaを最大限に活用いただけるようサポートします。これには、チームに新たに加わったメンバーに対する細やかなオリエンテーション、マニュアルやビデオウォークスルーが含まれます。
                            </p>
                        </div>
                    </div>
                </div>

            </div>
            

        </div>
    </div>

</div>


<section class="list-wrapper-style-2">
    <div class="trinka_container">
        <div class="row">
            <div class="col-12">
                <div class="section-usecases section-purple rounded-sm">
                    <div class="row justify-content-center">
                        <div class="col-md-12 col-lg-12">
                            <div class="trinka-title mb-0 text-center">
                                <h2>教育 & eラーニング業界向けのTrinka Enterprise</h2>
                                <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                                <p>教育プラットフォームに最適なTrinkaの機能</p>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-6 col-md-6">
                            <div class="list-wrapper-content-2 list-style-cards  bt-none">
                                <h3>学習の習熟度確認</h3>
                                <p>学生のライティングスキルの上達度を、時系列で多角的に評価・追跡できます。
                                </p>
                                <ul>
                                    <li>ライティングスコア</li>
                                    <li>カテゴリー別の文法エラーレポート</li>
                                    <li>学習支援のための修正・提案</li>
                                </ul>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6">
                            <div class="list-wrapper-content-2 list-style-cards ">
                                <h3>強化できるポイントの特定</h3>
                                <p>ミスの種類・頻度の把握とカスタマイズ可能な指標により、学習者個人のニーズを特定します。</p>
                                <ul>
                                    <li>カスタマイズ可能な英文評価指標アルゴリズム</li>
                                    <li>カテゴリ別のミスの概要</li>
                                    <li>評価とフィードバックに有効な修正履歴</li>
                                </ul>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6">
                            <div class="list-wrapper-content-2 list-style-cards bt-1">
                                <h3>リアルタイムの学習サポート</h3>
                                <p>TrinkaのAIは、リアルタイムで英文の質を評価し修正と改善案の提案を行います。これにより、学習者が改善すべき箇所を理解し、より良いライティングスキルを身につけることができます。</p>
                                <ul>
                                    <li>ライティングの実践的な習得</li>
                                    <li>丁寧な解説付き添削</li>
                                    <li>インタラクティブなスコア</li>

                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<div class="cloud_key_features section-pd list-wrapper-style-2 tailoredSolutions">
    <div class="trinka_container">
        <div class="row justify-content-center">
            <div class="col-md-11 col-lg-10">
                <div class="trinka-title mb-0 text-center">
                    <h2>どこにいても使えるライティングツール</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                    <p>TrinkaはブラウザからMicrosoft Wordまで幅広いプラットフォーム上での英文ライティングをサポートします。</p>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards bt-none">
                    <h3>Trinka Cloud（クラウドベース）</h3>
                    <p>
                        セキュリティで保護されたWebベースのチェッカーで、どこからでもTrinkaを最大限に活用できます。
                    </p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards">
                    <h3>Word プラグイン</h3>
                    <p>
                        Wordのファイル内にリアルタイムで修正案が提示され、チームの作業効率をアップ。
                    </p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards">
                    <h3>ブラウザ プラグイン</h3>
                    <p>
                        各種ブラウザへのプラグインで、あらゆるサイトに入力する英文をリアルタイムにチェック。
                    </p>
                </div>
            </div>
            
        </div>
    </div>
</div>

<div class="section-pd section-purple">
    <div class="trinka_container">
        <div class="row justify-content-center">
            <div class="col-md-12 col-lg-12">
                <div class="trinka-title text-center">
                    <h2>まずはお気軽にお問い合わせください</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                    <p>Trinkaは、お客様独自のニーズに合わせ、ユーザー単位や使用量に応じた柔軟な価格設定を行っています。ユーザーの移行や利用制限をリアルタイムに行うことができ、追加料金もかかりません。お客様のご事情にあわせた契約で、請求書ベースでのお支払いも可能です。</p>
                    <div class="btn-group justify-content-center mt-4">
                        <button style="margin: 0; padding: 0;" id="salesContactButtons" data-toggle="modal"
                        data-target="#EnterPriseContactPopup" class="filled-btn" type="submit">お問い合わせ</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="trinka-banner section-pd-sm">
    <div class="trinka_container">
        <div class="row align-items-center justify-content-center">
            <div class="col-md-6 col-lg-6">
                <div class="trinka-title">
                    <h3 class="text-white mb-4">Trinkaのお支払いは、日本円でのお振込みにも対応</h3>
                    <p class="text-white">銀行振り込みでのご利用料金のお支払いをご希望のお客様には請求書をお送りしています。適格請求書がご入用な場合、お気軽にお申し付けください。日本での販売代理店である株式会社クリムゾンインタラクティブ・ジャパンが、日本円建ての適格請求書を発行いたします。</p>
                </div>
                <div class="btn-group">
                    <a [routerLink]="['/local-invoice']" class="white-btn">請求書の詳細を見る</a>
                </div>
            </div>
            <div class="col-md-6 col-lg-6">
                <div class="text-center mt-sm-30">
                    <img src="../../../assets/images/local-inovice-element.png" alt="現地の請求書 - 英文校正" class="img-fluid" />
                </div>
            </div>
        </div>  
    </div>
</div>

<section class="section-pd list-wrapper-style-2">
    <div class="trinka_container">
        <div class="row align-items-center flex-row-reverse">
            <div class="col-md-6">
                <div class="list-wrapper-content-2">
                    <h3>万全のセキュリティ</h3>
                    <p>Trinkaは、データの安全性とプライバシーを最重視した設計になっています。お客様のデータは高度に暗号化され、安全に保管されます。第三者がお客様のデータにアクセスすることはありません。ライティングの提案後に、データを完全に抹消するプランもご用意しています。
                    </p>
                </div>
            </div>
            <div class="col-md-6">
                <div class="list-wrapper-image">
                    <img src="../../../assets/images/safe-secure.png" alt="万全のセキュリティ - 文法 チェック" class="img-fluid">
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section-pd list-wrapper-style-2 pt-0">
    <div class="trinka_container">
        <div class="row align-items-center">
            <div class="col-md-6">
                <div class="list-wrapper-content-2 pr-80">
                    <h3>AIについて</h3>
                    <p>Trinkaは、コミュニケーションの障壁がない未来を願って、言語学者、医学校正者、データサイエンティスト、エンジニアらのチームによって開発されました。</p>
                    <p>Trinkaは、最新の機械学習（ML）と自然言語処理（NLP）の技術を使用して、文法の誤りを特定し、言語の改善案を提案します。医学、ライフサイエンス、生物学、物理科学、工学、人文科学、ビジネス、芸術を含む1300以上の分野の上質な論文や記事を数百万単位で読み込むことでAIが学習し、最適な提案をします。
                    </p>
                </div>
            </div>
            <div class="col-md-6">
                <div class="list-wrapper-image">
                    <img src="../../../assets/images/about-ai.png" alt="AIについて - 英文チ ェッカー" class="img-fluid">
                </div>
            </div>
        </div>
    </div>
</section>

<div class="trinka-banner section-pd-sm">
    <div class="trinka_container">
        <div class="row justify-content-center">
            <div class="col-md-12 col-lg-10">
                <div class="trinka-title text-center">
                    <h3 class="text-white">学生の英語ライティング力向上を、Trinkaで</h3>
                </div>
                <div class="btn-group justify-content-center">
                    <button id="salesContactButtons" data-toggle="modal" data-target="#EnterPriseContactPopup"
                    class="white-btn" type="submit">購入する</button>
                </div>
            </div>
        </div>  
    </div>
</div>

<app-enterprise-modal></app-enterprise-modal>